/* src/app/private/configrations/scholarship-configuration/scholarship-configuration.component.scss */
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
/*# sourceMappingURL=scholarship-configuration.component.css.map */
